import { CloselinkWordmark } from './common/icons/closelink/CloselinkWordmark';

export const LoadingWithWobble = () => {
    return (
        <div className="app-loading">
            <div className="spinner-content">
                <div className="img-container">
                    <CloselinkWordmark color="blue" />
                </div>

                <div style={{ margin: '0 auto' }}>
                    <div className="line-wobble" />
                </div>
            </div>
        </div>
    );
};
